module.exports = __webpack_public_path__ + "media/src/images/page01_faq04-bb62be06b26c822e015d9f86cf56cdd4.jpg";